var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}.cls-3{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 10.47,
    y1: -156.22,
    x2: 96.98,
    y2: -224.89,
    gradientTransform: "translate(0 -137.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9013fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6610f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 37.07,
    y1: -169.88,
    x2: 56.41,
    y2: -202.58,
    gradientTransform: "translate(0 -137.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1e5fc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11.42,20.86c-.19-5.36,3.99-10.31,9.64-10.31h57.88c5.65,0,9.83,4.95,9.64,10.31-.18,5.15.05,11.83,1.73,17.27,1.69,5.46,4.53,8.91,9.18,9.35v5.03c-4.65.44-7.5,3.89-9.18,9.35-1.68,5.44-1.91,12.12-1.73,17.27.19,5.36-3.99,10.31-9.64,10.31H21.06c-5.65,0-9.83-4.95-9.64-10.31.18-5.15-.05-11.83-1.73-17.27-1.68-5.46-4.53-8.91-9.19-9.35v-5.03c4.65-.44,7.5-3.89,9.19-9.35,1.68-5.44,1.91-12.12,1.73-17.27Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m52.15,70.97c9.15,0,14.66-4.48,14.66-11.86,0-5.58-3.93-9.62-9.77-10.26v-.23c4.29-.7,7.66-4.68,7.66-9.13,0-6.34-5-10.47-12.63-10.47h-17.16v41.96h17.25Zm-10.58-36.64h8.88c4.83,0,7.57,2.15,7.57,6.05,0,4.16-3.19,6.48-8.97,6.48h-7.48v-12.53Zm0,31.32v-13.81h8.82c6.32,0,9.59,2.33,9.59,6.86s-3.19,6.95-9.2,6.95h-9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m52.15,71.47h-17.75V28.51h17.66c7.85,0,13.13,4.41,13.13,10.97,0,4.05-2.68,7.78-6.36,9.17,5.14,1.23,8.48,5.26,8.48,10.46,0,7.63-5.81,12.36-15.16,12.36Zm-16.75-1h16.75c8.86,0,14.16-4.25,14.16-11.36,0-5.31-3.66-9.15-9.33-9.77l-.45-.05v-1.11l.42-.07c4.06-.66,7.24-4.45,7.24-8.64,0-6.06-4.76-9.97-12.13-9.97h-16.66v40.96Zm15.38-4.32h-9.71v-14.81h9.32c8.34,0,10.09,4,10.09,7.36,0,4.8-3.45,7.45-9.71,7.45Zm-8.71-1h8.71c3.97,0,8.71-1.12,8.71-6.45,0-4.22-3.06-6.36-9.09-6.36h-8.32v12.81Zm6.98-17.78h-7.98v-13.53h9.38c5.13,0,8.07,2.39,8.07,6.55,0,4.44-3.45,6.98-9.47,6.98Zm-6.98-1h6.98c5.46,0,8.47-2.12,8.47-5.98,0-3.58-2.51-5.55-7.07-5.55h-8.38v11.53Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.762fe0ce7d0fee53683cd71675749764.svg";
export { ForwardRef as ReactComponent };